<template>
  <div
    id="cloud-canvas-el"
    style="display: flex;"
  >
    <canvas
      id="cloud-canvas-bg"
      style="margin: 0 auto;"
    ></canvas>
  </div>
</template>

<script>
import * as THREE from "three"
	import {
		TextureEffect,
		BlendFunction,
		BloomEffect,
		KernelSize,
		EffectPass,
		EffectComposer,
		RenderPass
	} from "postprocessing";
export default {
  name: "cloud-canvas-3d",
  props: {
    screen: String,
  },
  data() {
    return {
      renderer: null,
    }
  },
  destroyed() {
    this.renderer.setAnimationLoop(null)
    this.renderer.domElement.parentElement.removeChild(this.renderer.domElement)
  },
  mounted() {
    let scene,
      camera,
      cloudParticles = [],
      composer
    scene = new THREE.Scene()
    camera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      1,
      1000
    )
    camera.position.z = 1
    camera.rotation.x = 1.16
    camera.rotation.y = -0.12
    camera.rotation.z = 0.27

    let ambient = new THREE.AmbientLight(0x555555)
    scene.add(ambient)

    let directionalLight = new THREE.DirectionalLight(0xff8c19)
    directionalLight.position.set(0, 0, 1)
    scene.add(directionalLight)

    let orangeLight = new THREE.PointLight(0xcc6600, 50, 450, 1.7)
    orangeLight.position.set(200, 300, 100)
    scene.add(orangeLight)
    let redLight = new THREE.PointLight(0xd8547e, 50, 450, 1.7)
    redLight.position.set(100, 300, 100)
    scene.add(redLight)
    let blueLight = new THREE.PointLight(0x3677ac, 50, 450, 1.7)
    blueLight.position.set(300, 300, 200)
    scene.add(blueLight)

    const cloudCanvasBg = document.getElementById("cloud-canvas-bg")

    const renderer = new THREE.WebGLRenderer({ canvas: cloudCanvasBg })
    this.renderer = renderer
    
    scene.fog = new THREE.FogExp2(0x03544e, 0.001)
    renderer.setClearColor(scene.fog.color)
    if (this.screen != "home") {
      renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer = renderer
      renderer.render(scene, camera)
    }

    let loader = new THREE.TextureLoader()
    loader.load("smoke.png", function (texture) {
      const cloudGeo = new THREE.PlaneBufferGeometry(500, 500)
      const cloudMaterial = new THREE.MeshLambertMaterial({
        map: texture,
        transparent: true,
      })

      for (let p = 0; p < 50; p++) {
        let cloud = new THREE.Mesh(cloudGeo, cloudMaterial)
        cloud.position.set(
          Math.random() * 800 - 400,
          500,
          Math.random() * 500 - 500
        )
        cloud.rotation.x = 1.16
        cloud.rotation.y = -0.12
        cloud.rotation.z = Math.random() * 2 * Math.PI
        cloud.material.opacity = 0.55
        cloudParticles.push(cloud)
        scene.add(cloud)
      }
    })
    loader.load("stars.jpg", function (texture) {
      const textureEffect = new TextureEffect({
        blendFunction: BlendFunction.COLOR_DODGE,
        texture: texture,
      })
      textureEffect.blendMode.opacity.value = 0.2

      const bloomEffect = new BloomEffect({
        blendFunction: BlendFunction.COLOR_DODGE,
        kernelSize: KernelSize.SMALL,
        useLuminanceFilter: true,
        luminanceThreshold: 0.3,
        luminanceSmoothing: 0.75,
      })
      bloomEffect.blendMode.opacity.value = 1.5

      let effectPass = new EffectPass(
        camera,
        bloomEffect,
        textureEffect
      )
      effectPass.renderToScreen = true

      composer = new EffectComposer(renderer)
      composer.addPass(new RenderPass(scene, camera))
      composer.addPass(effectPass)

      // window.addEventListener("resize", onWindowResize, false);
      function onWindowResize() {
        camera.aspect = window.innerWidth / window.innerHeight
        camera.updateProjectionMatrix()
        renderer.setSize(window.innerWidth, window.innerHeight)
      }
      function render() {
        cloudParticles.forEach((p) => {
          p.rotation.z -= 0.001
        })
        composer.render(0.1)
        requestAnimationFrame(render)
      }
      render()
    })
  },
}
</script>